module.exports = __webpack_public_path__ + "media/images/athletes/3412-acb1e35b5eb01bb790eaf9499b922f07.png";